import React from 'react';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyAlertPolicies: LazyComponent<any> = lazyForPaint<any>(
	() =>
		import(
			/* webpackChunkName: "async-jira-eoc-policies", jiraSpaEntry: "async-jira-eoc-policies" */ '@jira/eoc__policies/src/index.tsx'
		),
);

export const AlertPoliciesComponent = (): React.JSX.Element => (
	<LazyPage
		Page={LazyAlertPolicies}
		pageId="async-jira-eoc-alert-policies"
		shouldShowSpinner={false}
	/>
);
